import { Component, OnInit, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { ResetPasswordService } from 'src/app/shared/services/reset-password.service';
import { NotifyService } from 'src/app/shared/services/notify.service';
import { CustomValidator } from 'src/app/shared/validators/custom-validator';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.scss']
})
export class RecoverPasswordComponent implements OnInit {
  instructionSent : boolean  = false;
  public formAuth: FormGroup = this.formBuilder.group({
    email: ['', [Validators.email] ],
    password: ['', Validators.required],
    confirmPassword: ['', [CustomValidator.equalsTo('password')]]
  })
  error = false
  loading = false
  token: string | null
  showPasswordForm = false
  errorMessage: string = ''
  success = false;


  slides = [
    { img: 'assets/slide.png', active: true },
    { img: 'assets/slide2.png', active: false },
    { img: 'assets/slide3.png', active: false } 
  ];

  latX = 0;

  ignoreInterval = false;

  @ViewChildren('img') imgs!: any;

  constructor(
    private formBuilder: FormBuilder, 
    private router: Router, 
    private authentication: AuthenticationService,
    private resetPasswordService: ResetPasswordService,
    private notifyService: NotifyService,
    private route: ActivatedRoute
  ) {
    this.token = this.route.snapshot.queryParamMap.get('token');
  }
  ngOnInit(): void {
    setInterval(() => {
      if(!this.ignoreInterval){
        this.nextSlide(false); 
      } else {
        this.ignoreInterval = false;
      }
    }, 5000)


    if(this.token){
      this.showPasswordForm = true
    }
  }

  navigateLogin() {
    this.router.navigate(['login']);
  }

  prevSlide(ignoreInterval = true) {
    if(ignoreInterval){
      this.ignoreInterval = true;
    }
    let index = this.slides.findIndex((x: any) => x.active == true);
    this.slides[index].active = false;
    let width = this.imgs.get(index).nativeElement.offsetWidth;
    if(index > 0){
      this.slides[index - 1].active = true;
      this.latX = ((index - 1) * -1) * (width + 52); //52
    }else{
      this.slides[this.slides.length - 1].active = true;
      this.latX = ((this.slides.length - 1) * -1) * (width + 52);
    }
  }

  nextSlide(ignoreInterval = true) {
    if(ignoreInterval){
      this.ignoreInterval = true;
    }
    let index = this.slides.findIndex((x: any) => x.active == true);
    this.slides[index].active = false;
    let width = this.imgs.get(index).nativeElement.offsetWidth;
    if(index < (this.slides.length - 1)){
      this.slides[index + 1].active = true;
      this.latX = ((index + 1) * -1) * (width + 55);
    }else{
      this.slides[0].active = true;
      this.latX = 0;
    }
  }



  redefinirSenha() {
    this.loading = true
    if(this.formAuth.get('email')?.valid){
      this.resetPasswordService.save({ email: this.formAuth.value.email }).subscribe({
        next: (res: any) => {
          this.instructionSent = true;
          this.loading = false
        },
        error: (err: any) => { 
          this.error = true, this.loading = false }
      })
    } else {
      this.loading = false;
      this.error = true;
    }
  }

  sendNewPassword(){
    this.loading = true
    if(this.formAuth.get('password')?.valid && this.formAuth.get('confirmPassword')?.valid ){
      let password = this.formAuth.value.password
      this.resetPasswordService.sendNewPassword({token: this.token!, password: password }).subscribe({
        next: (res: any) => {
          this.loading = false
          this.success = true
        },
        error: (err: any) => {
          this.loading = false
          this.error = true
          err.msg ? this.errorMessage = 'Ocorreu um erro: ' + err?.msg : this.errorMessage = 'Ocorreu um erro'
        }
      })
    } else {
      this.loading = false
      this.error = true
      this.errorMessage = 'Senha inválida'
    }
  }
}
